var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"width":"150","src":require("../../../../src/assets/images/logo/logooffice4.png"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }